/**
 * @file 图片查看器
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import SwiperImage from './image.vue'

const SwiperImageConstructor = Vue.extend(SwiperImage)
let instance = new SwiperImageConstructor().$mount()

/**
 * SwiperImage
 * @param {Object} params - 参数对象
 * @param {Array} params.images - 包含图片 URL 的数据数组
 * @param {String} params.keyName - 图片字段名
 * @param {Boolean} [params.infinite=false] - 控制是否开启无限滑动效果
 * @param {Number} [params.index=0] - 设置组件初始化时默认为第几张，从 0 计数
 * @param {String} [params.transitionName='sui-animation--fade-fast'] - 图片查看器 打开 / 关闭 时的动画效果
 */
export default function SwiperImageInstance({
    images = [],
    keyName = '',
    infinite = false,
    index = 0,
    transitionName = 'sui-animation--fade-fast',
}) {
    instance.images = images
    instance.keyName = keyName
    instance.infinite = infinite
    instance.index = index
    instance.transitionName = transitionName
    instance.show = true
    document.body.appendChild(instance.$el)
}